import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/* Fetch all social media data */
export const getAllSocialMedia = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/social-media`);
        return response.data;
    } catch (error) {
        console.error("Error fetching social media data:", error);
        throw error;
    }
};

/* Create social media data */
export const createSocialMedia = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/social-media`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating social media data:", error);
        throw error;
    }
};

/* Update social media data */
export const updateSocialMedia = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/social-media/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating social media data with ID ${id}:`, error);
        throw error;
    }
};

/* Delete social media data */
export const deleteSocialMedia = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/social-media/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting social media data with ID ${id}:`, error);
        throw error;
    }
};
